import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasDecisionPageAccess } from '../../constants/decision-page-access';
import { UtilitiesService } from '../../services/utilities.service';

function resolveClientId(route: {
  paramMap: { get: (key: string) => string | null };
  parent?: { paramMap: { get: (key: string) => string | null }; parent?: { paramMap: { get: (key: string) => string | null } } | null } | null;
}): number | null {
  const raw =
    route.paramMap.get('clientId') ??
    route.parent?.paramMap.get('clientId') ??
    route.parent?.parent?.paramMap.get('clientId') ??
    null;

  if (!raw || Number.isNaN(Number(raw))) {
    return null;
  }

  return Number(raw);
}

function adminMerchantUrl(clientId: number, target: 'decision' | 'single-merchant') {
  return ['client', clientId, 'admin', target];
}

function merchantOnboardingEntry(clientId: number | null, isFdUser: boolean): 'decision' | 'single-merchant' {
  if (!clientId || hasDecisionPageAccess(clientId, isFdUser)) {
    return 'decision';
  }

  return 'single-merchant';
}

export const merchantDecisionGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const utilities = inject(UtilitiesService);
  const clientId = resolveClientId(route) ?? utilities.clientId;

  if (merchantOnboardingEntry(clientId, utilities.isFdUserValue) === 'decision') {
    return true;
  }

  return router.createUrlTree(adminMerchantUrl(clientId, 'single-merchant'));
};
